import React from 'react'
import { Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { dataConstants } from '../../../../constants';
import { getRandomStr, roundNum } from '../../../../helpers';
import { addCommas, getCssBarXPos } from '../../../../utils';
import { styled } from '@mui/material/styles';

const { ECO_SECTION_CODES } = dataConstants || {};

const margin_left = 6;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '&:hover button, .share-wrapper': {
    visibility: 'visible'
  },
  '& .Item-Head': {
    background: '#f2f2f2',
    // borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(2, 2, 0, 2),
    borderRadius: '4px 4px 0 0',
    '& a': {
      textDecoration: 'none',
      color: '#333',
      fontWeight: 600,
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#000000',
      fontSize: '.875',
    }
  },
}));


const getGDPChildrens = (breakData, data, parent, rows, level = 1) => {
  // let children = parent.children.map(d => ({
  //     ...d,
  //     htmlStr: getGdpRowBody(d, breakData, level),
  //     //children: getGDPChildrens(breakData, data, data.find(it => it.id === d.id), level + 1),
  // }));
  if (parent) {
    rows.push({ ...parent, htmlStr: getGdpRowBody({ header: data.header, body: parent }, breakData, level) });

    parent.children.forEach(d => {
      rows = getGDPChildrens(breakData, data, data.body.find(it => it.id === d.id), rows, level + 1);
    });
  }

  return rows;
}

const getGdpTableStruct = (breakData, gdpTbl = []) => {
  const header = gdpTbl.find(d => d.id === 0);
  let body = gdpTbl.filter(d => d.id > 0);
  body = body.sort((a, b) => a.seq - b.seq);

  let cols = body.map(d => d.cols);

  cols = header.cols.map((d, i) => d.chart === 'bar' ? { ...d, values: cols.map(it => breakData.find(d => d.code === it[i - 1]) ? breakData.find(s => s.code === it[i - 1]).value : 0) } : d);
  cols = cols.map(d => d.chart === 'bar' && d.values ? { ...d, max: Math.max(...d.values), min: Math.min(...d.values) } : d);

  let bodyRows = [];

  if (body && body.length > 0) {
    body = body.map(d => ({
      ...d,
      children: body.filter(it => it.parentID === d.id),
    }));

    const parents = body.filter(d => !d.parentID);

    parents.forEach(d => {
      //const level = 1;
      //bodyRows.push({...d, htmlStr: getGdpRowBody(d, breakData, 1)});
      bodyRows = getGDPChildrens(breakData, { header: cols.filter((d, i) => i > 0), body }, d, bodyRows);
    });
  }

  return { header, body: bodyRows };
}

const getCellShape = (item, val, level) => {
  switch (item.chart) {
    case 'pie':
      return (<td className={level === 1 ? 'gdp-par-cell' : ''}><Box component="div" className="gdp-pie-chart" style={{ backgroundImage: `conic-gradient(#174C86 ${val}%, #EFEFEF ${val}%, #EFEFEF)` }}></Box></td>);
    case 'bar':
      const zeroPos = roundNum(getCssBarXPos(item.min, item.max), 4) * 100;
      const valPos = roundNum(getCssBarXPos(item.min, item.max, val), 4) * 100;
      //return (<td className={level === 1 ? 'gdp-par-cell' : ''}><Box component="div" className="gdp-bar-chart" style={val >= 0 ? {width: `${100 - zeroPos}%`,float: 'right', borderLeft:`${val}px solid #0e9e19`} : {width: `${zeroPos}%`, float: 'left', borderRight:`${Math.abs(val)}px solid #ff0000`}}></Box></td>);
      return <td className={`gdp-bar-col ${level === 1 ? 'gdp-par-cell' : ''}`}><Box component="div" className="gdp-bar-chart" style={{ backgroundImage: val >= 0 ? `linear-gradient(to right, white 0%, white ${zeroPos}%, #0e9e19 ${zeroPos}%, #0e9e19 ${valPos}%, white ${valPos}%)` : `linear-gradient(to right, white 0%, white ${valPos}%, #EB0000 ${valPos}%, #EB0000 ${zeroPos}%, white ${valPos}%)` }}> </Box></td>;
    default:
      return null;
  }
}

const getGdpRowBody = ({ body, header = [] }, breakData, level) => {
  return (
    <tr>
      <td className={level === 1 ? 'gdp-par-cell' : ''} style={{ paddingLeft: `calc(1em + ${margin_left * (level - 1)}px)` }}>{body.desc}</td>
      {body.cols.map((d, i) => {
        const item = breakData.find(it => it.code === d);
        return (!header[i].chart ?
          <td key={d + i} className={`${header[i].formula ? 'td-right' : ''} ${level === 1 ? 'gdp-par-cell' : ''}`}>
            <span>{item && header[i] ? (header[i].formula ? addCommas(roundNum(eval(header[i].formula.replace('#value', item.value)), 0)) : item.value) : ''}</span>
          </td>
          :
          ([1, 2].map((it, j) => {
            return (item ? (j === 0 ?
              <td key={d + j} className={`${header[i].formula ? 'td-right' : ''} ${level === 1 ? 'gdp-par-cell' : ''}`}>
                <span>{item && header[i] ? (header[i].formula ? addCommas(roundNum(eval(header[i].formula.replace('#value', item.value)), 0)) : item.value) : ''}</span>
              </td>
              :
              getCellShape(header[i], item.value, level))
              :
              <td></td>
            );
          }))
        );
      })}
    </tr>
  );
}

function GDPComponents({ data }) {

  //gdp break table
  const gdpBreakTbl = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_TABLE) ? data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_TABLE) : undefined;
  const gdpBreakTableData = gdpBreakTbl && gdpBreakTbl.tabData && gdpBreakTbl.tabData.length > 0 ? gdpBreakTbl.tabData : undefined;
  const gdpBreakTblStruct = gdpBreakTbl && gdpBreakTableData && gdpBreakTbl.settings && gdpBreakTbl.settings.table ? getGdpTableStruct(gdpBreakTableData, gdpBreakTbl.settings.table) : undefined;

  return (
    <>
      {gdpBreakTbl && gdpBreakTblStruct && gdpBreakTableData &&
        <Item component="div" className="col-md-4" sx={{ height: '100%' }}>
          <Box className="Item-Head" >
            <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
              {gdpBreakTbl.section_name}
            </Typography>
          </Box>
          <Box component="div" className="option-content" sx={{ position: 'relative' }}>
            {gdpBreakTbl && gdpBreakTblStruct && gdpBreakTableData &&
              <TableContainer className="option-content">
                <Table
                  size="small"
                  aria-label="a densgdpBreakTblStructe table"
                  sx={{
                    '& thead tr': { background: '#f2f2f2' },
                    '& th': { color: 'rgb(112, 112, 112)', fontSize: '.875rem' },
                    '& td.gdp-par-cell': { fontWeight: 600, color: '#000' },
                    '& tbody tr': { borderBottom: '1px solid #fff' },
                    '& tbody tr:hover': { borderBottom: '1px solid #00000017' },
                    '& th:nth-child(2), th:nth-child(5), th:nth-child(4)': { textAlign: 'center' },
                    '& tr td:nth-child(2), tr td:nth-child(5),tr td:nth-child(4)': { textAlign: 'center' },
                    '& td': { background: '#fff', color: 'rgb(67, 65, 102)', fontSize: '.875rem', py: 1 },
                    '& .gdp-bar-chart': { width: '100%', height: '1rem', },
                    '& .gdp-pie-chart': { width: '1rem', height: '1rem', borderRadius: '50%', boxShadow: 2 },
                    '& .gdp-bar-col': { bgcolor: '#fff', minWidth: 80, px: 2 }
                  }}
                >
                  <TableHead>
                    <TableRow hover>
                      {gdpBreakTblStruct.header.cols.map(d => {
                        return (!d.chart ?
                          <TableCell className={d.formula ? 'td-right' : ''} key={getRandomStr(3)}>
                            {d.name}
                          </TableCell>
                          :
                          ([1, 2].map((it, j) => {
                            return (
                              j === 0 ?
                                <TableCell className={d.formula ? 'td-right' : ''} key={getRandomStr(3) + j}>
                                  {d.name}
                                </TableCell>
                                :
                                <TableCell></TableCell>
                            );
                          }))
                        );
                      })}
                      {/* <TableCell></TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {gdpBreakTblStruct.body.map(d => d.htmlStr)}
                  </TableBody>
                </Table>
              </TableContainer>}
          </Box>
        </Item>}
    </>
  )
}

export default GDPComponents
